<template>
  <div>
    <HeaderContent title="Extracharge" />
    <ActionContent
      ctaText="Add Extracharge"
      @action="showModal"
      :filterDate="false"
      :filterModal="false"
      v-model:search="search"
      @search-query="searchData"
    />
    <ExtraChargeStatistics title="Extra Charge Statistics" :data="statistics" />
    <ExtraChargeForm
      :modal="modal"
      :extraChargeData="extracharge"
      @update:modal="updateModal"
      @addOrUpdate="getAll"
    />
    <ExtraChargeConfirm
      title="Confirmation"
      :uuid="extrachargeUuid"
      v-model="modalConfirm"
      @confirmed="deleteData(extrachargeUuid)"
    >
      <template #text>Are you sure to delete this data ?</template>
    </ExtraChargeConfirm>
    <ExtraChargeDataTable
      :data="extracharges"
      :header="headers"
      :currentPage="currentPage"
      :custom-actions="customActions"
    />
  </div>
</template>

<script>
import { ref, inject, onMounted } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import ExtraChargeForm from "./ExtraChargeForm.vue";
import ExtraChargeConfirm from "@/components/ModalDialog.vue";
import ExtraChargeStatistics from "@/components/StatisticData.vue";
import ExtraChargeDataTable from "@/components/DataTable.vue";
import iconCategory from "../../../public/icons/category-alt.svg";
import iconItem from "../../../public/icons/boxes.svg";
import { formatIDR } from "@/utils/currency";

export default {
  components: {
    HeaderContent,
    ActionContent,
    ExtraChargeForm,
    ExtraChargeConfirm,
    ExtraChargeStatistics,
    ExtraChargeDataTable,
  },
  setup() {
    const repositories = inject("repositories");
    const extraChargeRepository = repositories
      ? repositories.extraCharges
      : null;

    const modal = ref(false);
    const modalConfirm = ref(false);
    const extrachargeUuid = ref(null);
    const extracharges = ref([]);
    const extracharge = ref({});
    const search = ref("");

    const customActions = ref([
      {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
        },
      },
    ]);

    const headers = ref([
      {
        key: "no",
        label: "#",
        tdClass: "text-center",
      },
      {
        key: "extracharge_category.name",
        label: "Category",
        sortable: true,
        tdClass: "text-left",
      },
      {
        key: "name",
        label: "Name",
        sortable: true,
        tdClass: "text-left",
      },
      {
        key: "price",
        label: "Price",
        sortable: true,
        tdClass: "text-right",
        formatter: (value) => formatIDR(value),
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);
    const statistics = ref([
      {
        label: "Total",
        key: "Category",
        value: 3,
        color: "primary",
        icon: iconCategory,
      },
      {
        label: "Total",
        key: "Item",
        value: 5,
        color: "primary",
        icon: iconItem,
      },
    ]);

    const getAll = async (searchQuery = "") => {
      const params = {};
      if (searchQuery) params.search = searchQuery;
      await extraChargeRepository
        .getAll(params)
        .then((res) => {
          extracharges.value = res.data.data;

          const allData = res.data.data;

          const categoryCount = allData.filter(
            (item) => item.extracharge_category?.name
          ).length;
          const itemCount = allData.filter((item) => item.name).length;

          // Update statistik
          const categoryStat = statistics.value.find(
            (stat) => stat.key === "Category"
          );
          const itemStat = statistics.value.find((stat) => stat.key === "Item");

          if (categoryStat) categoryStat.value = categoryCount;
          if (itemStat) itemStat.value = itemCount;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getById = async (uuid) => {
      await extraChargeRepository
        .getById(uuid)
        .then((res) => {
          extracharge.value = res.data.data;
          modal.value = true;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const updateModal = (newValue) => {
      modal.value = newValue;
      extracharge.value = {};
    };
    const showModal = () => {
      modal.value = true;
      extracharge.value = { extra_charge_category_uuid: null };
    };
    const showConfirmModal = async (uuid) => {
      modalConfirm.value = true;
      extrachargeUuid.value = uuid;
    };
    const deleteData = async (uuid) => {
      await extraChargeRepository
        .delete(uuid)
        .then(() => {
          modalConfirm.value = false;
          getAll();
        })
        .catch((err) => {
          console.error(err);
        });
    };

    function handleSearch(query) {
      search.value = query;
      getAll(query);
    }
    const searchData = async (query) => {
      getAll(query);
    };

    onMounted(() => {
      getAll();
    });

    return {
      getAll,
      getById,
      updateModal,
      showModal,
      deleteData,
      extracharges,
      extracharge,
      extrachargeUuid,
      headers,
      modal,
      modalConfirm,
      customActions,
      statistics,
      search,
      searchData,
      handleSearch,
    };
  },
};
</script>

<style></style>
